import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from 'components/forms/new/formikFormFields/BooleanToggle';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const SipEnabledField = ({ darkMode, values, setFieldValue }) => (
    <FormControl sx={{ margin: '0 !important' }}>
        <Stack
            direction="row"
            alignItems="center"
            spacing={stackSpacing}
            sx={stackStyling()}>
            <FormLabel sx={formLabelStyling(darkMode, true)}>
                SIP Enabled
            </FormLabel>
            <Field
                name="sipEnabled"
                component={BooleanToggle}
                isChecked={values?.sipEnabled ?? false}
                onChange={(value) => setFieldValue('sipEnabled', value)}
            />
        </Stack>
    </FormControl>
);

export default SipEnabledField;
